<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      show-overflow
      :height="800"
      :data="data"
      :loading="loading"
      :columns="tableColumns"
      :row-class-name="rowClassName"
    />
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    data: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  methods: {
    rowClassName({ row }) {
      const { errorMsg } = row
      return !errorMsg ? '' : 'bg-danger text-white'
    },
  },
}
</script>
